// import 'wa-mediabox/dist/wa-mediabox.min.css'
// import 'wa-mediabox'
import mediabox from 'mediabox';
import 'mediabox/dist/mediabox.min.css'

if(document.querySelector('.nosotros')){
    mediabox("#videonosotros");
}